import {
  Avatar,
  Badge,
  Button,
  Flex,
  Td,
  Text,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";

function TablesTableRow(props) {
  const { logo, name, email, subdomain, domain, status, date, isLast } = props;
  const textColor = useColorModeValue("gray.500", "white");
  const titleColor = useColorModeValue("gray.700", "white");
  const bgStatus = useColorModeValue("gray.400", "navy.900");
  const borderColor = useColorModeValue("gray.200", "gray.600");

  function formatearFecha(fechaString) {
    const opciones = {
      day: "2-digit",
      month: "short",
      year: "numeric",
    };

    const fecha = new Date(fechaString);

    if (!(fecha instanceof Date) || isNaN(fecha)) {
      console.error("Valor de fecha inválido:", fecha);
      return "Fecha inválida"; // O maneja el error de otra manera
    }

    //console.log(new Intl.DateTimeFormat('es-ES', opciones).format(fecha))

    return new Intl.DateTimeFormat("es-ES", opciones).format(fecha);
  }

  return (
    <Tr>
      <Td
        minWidth={{ sm: "250px" }}
        pl="0px"
        borderColor={borderColor}
        borderBottom={isLast ? "none" : null}
      >
        <Flex align="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
          <img src={logo} width="40px" style={{ borderRadius: "8px" }} />{" "}
          &nbsp;&nbsp;
          <Flex direction="column">
            <Text
              fontSize="md"
              color={titleColor}
              fontWeight="bold"
              minWidth="100%"
            >
              {name}
            </Text>
          </Flex>
        </Flex>
      </Td>

      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Flex direction="column">
          <Text fontSize="md" color={textColor} fontWeight="bold">
            {domain}
          </Text>
          <Text fontSize="sm" color="gray.400" fontWeight="normal">
            {subdomain}
          </Text>
        </Flex>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Badge
          bg={status === "Cliente" ? "green.400" : bgStatus}
          color={status === "Cliente" ? "white" : "white"}
          fontSize="16px"
          p="3px 10px"
          borderRadius="8px"
        >
          {status}
        </Badge>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Text fontSize="md" color={textColor} fontWeight="bold" pb=".5rem">
          {formatearFecha(date)}
        </Text>
      </Td>
    </Tr>
  );
}

export default TablesTableRow;
